export default "__VITE_ASSET__AQak$R4X__"